import React, {Fragment, useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../Escritorio/Instrucciones';
import useConfigAuth from '../../../../../Hooks/useConfigAuth';
import BotoneraBottom from '../../../Compartidos/BotoneraBottom';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../actions/almacenarEjercicioActions';

// css
import {Flex, Ilustracion } from '../../../../Css/MetodosCSS/StyledRimaLexica';
import { CirculoScreening } from '../../../../Css/MetodosCSS/StyledCCSilabica';
import { BtnColor, Img } from '../../../../Css/MetodosCSS/StyledLectoEscritura';

const instrucciones = 'Escucha el sonido. Descubre en qué sílaba se encuentra escondido el sonido.';
const miniInstrucciones = 'Escucha el sonido. Descubre en qué sílaba se encuentra escondido el sonido.';

const LEN32 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [indexes, setIndexes] = useState([]);
    const [contarErrores, setContarErrores] = useState(0);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const ayuda_imagen = useSelector((state) => state.configuracion.ayuda_imagen);
    const lista_usada = useSelector(state => state.informacion.lista_usada);
    const lista = useSelector(state => state.ejercicio.lista);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const play1 = () => {
        new Audio(`/sounds/${comparar.sonido_url_1}.mp3`).play();
    }


   const verificar = (e, silaba_elegida) => {
        e.preventDefault();
        if(disable) {return}
        if(comparar.palabra_1_silaba_1.toString() === silaba_elegida.toString()) {
            console.log("bien");
            setDisable(true);
            setIsCorrect(true);
            setTimeout(() => {
                setIsCorrect(false);
            }, 300);
            GoodWork();
            if(count < indexes) {
                const newList = JSON.parse(JSON.stringify(comparar));
                newList.sonido_url_1 = '';
                setComparar(newList);
                setTimeout(() => {
                    setCount(count + 1);
                    setDisable(false);
                }, 1000);

            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    dispatch( finalizarEjercicioAction() )                        
                }, 1000);
            }
        } else {
            console.log("mal");
            setIsIncorrect(true);
            setContarErrores(contarErrores + 1);
            setDisable(true);
            setTimeout(() => {
                setIsIncorrect(false);
            }, 300);
            TryAgain();
            setTimeout(() => {
                setDisable(false);
            }, 1000);
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('LEN32') );
        dispatch(setearUrlAnteriorAction('lenguaje/conciencia-fonologica/cc-silabica/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length)
    }, [count, informacion])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);


    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                'ejercicio': "LEN32",
                'errores': contarErrores,
                'tiempo': tiempoFinal,
                'id_paciente': id_paciente,
                'lista_usada': lista_usada,
                'lista': lista,
                sesion
                }
            }

            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} ayuImagen={true} />
            {iniciar
                ?   
                <Fragment>
                    <Flex direction="column" height="100%">
                        {comparar.ejemplo ? 
                        <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                            Ejemplo
                        </Flex>
                        : null
                        }
                        <Flex justify="space-evenly" margin="auto">
                            <Flex margin="0 4rem 0 0">
                                <audio src={`/sounds/${comparar.sonido_url_1}.mp3`} autoPlay />
                                <BtnColor border="none" bg="transparent" 
                                    onClick={() => play1()}
                                >
                                    <Img alt='' w="70px" src={`/img/altavoz.png`} />
                                    {ayuda_imagen ? 
                                        <div>{comparar.ayuda_imagen_2}</div>
                                    : null}
                                </BtnColor>
                            </Flex>
                            
                            <Flex height="100%" direction="column">
                                <Flex margin="3rem 0px 4rem 0px" direction="column">
                                    <Ilustracion src={`/img/${comparar.imagen_url_1}.png`} width="15vw"
                                    isCorrect={isCorrect} 
                                    isIncorrect={isIncorrect}
                                    />
                                    {ayuda_imagen ? 
                                        <div>{comparar.ayuda_imagen_1}</div>
                                    : null}
                                </Flex>
                                
                                <Flex direction="row">
                                    <CirculoScreening backgroundcolor="#23AAAF"
                                        disabled={disable}
                                        onClick={(e) => verificar(e, "1")}
                                    >
                                    </CirculoScreening>
                                    <CirculoScreening backgroundcolor="#FFB526"
                                        disabled={disable}
                                        onClick={(e) => verificar(e, "2")}
                                    >
                                    </CirculoScreening>
                                    {comparar.cantidad_silabas >= "3" ?
                                    <CirculoScreening backgroundcolor="#FE6363"
                                        disabled={disable}
                                        onClick={(e) => verificar(e, "3")}
                                    >
                                    </CirculoScreening>
                                    :
                                    null
                                    }
                                    {comparar.cantidad_silabas >= "4" ?
                                    <CirculoScreening backgroundcolor="#9A5EE8"
                                        disabled={disable}
                                        onClick={(e) => verificar(e, "4")}
                                    >
                                    </CirculoScreening>
                                    :
                                    null
                                    }
                                </Flex>
                            </Flex>
                        </Flex>
                        <Flex align="center" justify="flex-start" width="90%" margin="0 0 1rem 0">
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        </Flex>
                    </Flex>
                </Fragment>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default LEN32;